import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { Phone } from 'emotion-icons/material';
import LinkButton from '../LinkButton/index.js';
import { Span } from './PhoneCTA.styles.js';
import useWindowSize from '../../hooks/useWindowSize.js';
import determineButtonText from '../../utils/determineButtonText.js';

var _excluded = ["children", "customClasses", "hidePhoneNumberOnMobile", "mobileText", "phoneNumber", "visibility"];
var PhoneCTA = function PhoneCTA(_ref) {
  var children = _ref.children,
    _ref$customClasses = _ref.customClasses,
    customClasses = _ref$customClasses === void 0 ? null : _ref$customClasses,
    _ref$hidePhoneNumberO = _ref.hidePhoneNumberOnMobile,
    hidePhoneNumberOnMobile = _ref$hidePhoneNumberO === void 0 ? false : _ref$hidePhoneNumberO,
    _ref$mobileText = _ref.mobileText,
    mobileText = _ref$mobileText === void 0 ? null : _ref$mobileText,
    _ref$phoneNumber = _ref.phoneNumber,
    phoneNumber = _ref$phoneNumber === void 0 ? null : _ref$phoneNumber,
    visibility = _ref.visibility,
    props = _objectWithoutProperties(_ref, _excluded);
  var windowSize = useWindowSize();
  var buttonText = determineButtonText(windowSize.width, mobileText, children);
  return /*#__PURE__*/React.createElement(LinkButton, _extends({
    visibility: visibility,
    className: "leshen-phone-cta ".concat(customClasses),
    to: "tel:".concat(phoneNumber),
    leftIcon: /*#__PURE__*/React.createElement(Phone, null)
  }, props), buttonText, ' ', /*#__PURE__*/React.createElement(Span, {
    hidePhoneNumberOnMobile: hidePhoneNumberOnMobile
  }, phoneNumber));
};
var PhoneCTA$1 = PhoneCTA;

export { PhoneCTA$1 as default };
//# sourceMappingURL=index.js.map
